import React from "react"

export const SignupForm = () => {
  return (
    /*<form action="//" target="_blank" method="post">
      <div className="flex flex-wrap lg:justify-between lg:items-center">
        <div>
          <h3 className="text-2xl lg:text-4xl font-bold text-blue-500 tracking-tight">
            Get in touch
          </h3>
        </div>
        <div className="flex w-full md:w-1/2 lg:w-auto">
          <input
            aria-label="E-mail address"
            className="flex-1 lg:w-64 rounded-l-lg placeholder-blue-800 text-blue-800 px-4 py-1 border border-blue-700 appearance-none rounded-left text-lg leading-loose focus:outline-none focus:shadow-outline"
            maxLength="60"
            name="email"
            placeholder="Your e-mail"
            required
            type="email"
          />
          <input
            className="rounded-r-lg text-center px-4 py-1 leading-loose text-lg font-medium transition-colors duration-200 focus:outline-none focus:shadow-outline bg-blue-700 text-white cursor-pointer hover:bg-blue-500"
            type="submit"
            value="Sign up"
          />
        </div>
      </div>
    </form>
  */
    <form 
    name="contact"
    method="post"
    action="/thanks/"
    data-netlify="true"
    data-netlify-honeypot="bot-field"
  >
          <div className="flex flex-wrap -mx-6 xl:-mx-12">
          <div className="w-full sm:w-1/1 xl:w-2/6">
          <p className="text-2xl lg:text-3xl xl:text-3xl font-bold leading-none">
            Have a resource or story? <br />
            Please get in touch!
          </p>
        </div>
    {/* The `form-name` hidden field is required to support form submissions without JavaScript */}
    <input type="hidden" name="form-name" value="contact" />
    <p hidden>
      <label>
        Don’t fill this out: <input name="bot-field" />
      </label>
    </p>
    <div className="w-full sm:w-1/1 xl:w-1/6">
      <label>
        Name
        <br />
        <input
            aria-label="Name"
            className="flex-none  rounded-lg placeholder-gray-800 text-gray-800 px-1 py-1 border border-gray-700 appearance-none rounded-left text-lg leading-loose focus:outline-none focus:shadow-outline"
            maxLength="60"
            name="name"
            placeholder="Your name"
            required
            type="text"
          />
      </label>
      </div>
    <div className="w-full sm:w-1/1 xl:w-1/6">
      <label>
        Email
        <br />
        <input
            aria-label="E-mail address"
            className="flex-none rounded-lg placeholder-gray-800 text-gray-800 px-1 py-1 border border-gray-700 appearance-none rounded-left text-lg leading-loose focus:outline-none focus:shadow-outline"
            maxLength="60"
            name="email"
            placeholder="Your e-mail"
            required
            type="email"
          />
      </label>
    </div>
    <div className="w-full sm:w-1/1 xl:w-1/6">
      <label>
        Message
        <br />
        <textarea aria-label="Message"
            className="flex-none rounded-lg placeholder-gray-800 text-gray-800 px-1 py-1 border border-gray-700 appearance-none rounded-left text-lg leading-loose focus:outline-none focus:shadow-outline"
            name="message"
            placeholder="Leave a message" />
      </label>
      </div>
    <div className="w-full sm:w-1/1 xl:w-1/6">
      <label>
        <div data-netlify-captcha></div>
        <br />
    <input
            className="rounded-lg text-center px-4 py-1 leading-loose text-lg font-medium transition-colors duration-200 focus:outline-none focus:shadow-outline bg-gray-700 text-white cursor-pointer hover:bg-gray-500"
            type="submit"
            value="Send"
          />
          </label>
    </div>
    </div>
  </form>
  )
}
